import React from 'react';
import i18n from '../../i18n/i18n.js';
import { Link } from "react-router-dom";
import AppHeader from '../../components/AppHeader/AppHeader';
import { Utils, NavigateTo } from '../../Utils';
import { ReactSVG } from 'react-svg';

import './SignIn.css'; 
import App from '../../App.js';

class SignIn extends React.Component {

  settings = {};

  logged_in = 0;
  remember_me_expire = 0;
  stored_hash = '';

  emptyFormData = {
      username: '',
      email: '',
      password: '',
      chb_newsletter: 0,
      remember_me: 1,

      // lost password 25.04.22
      new_password: '',
      new_password_repeat: '',
      email_pswpin_code: '',
  };

  emptyFormErrors = {
      /*  
      summary: 'Teszt hibaüzenet summary',
      banned: 'Teszt hibaüzenet banned',
      password: 'Teszt hibaüzenet password',
      email: 'Teszt hibaüzenet email',
      chb_newsletter: 'Teszt hibaüzenet chb_newsletter',
      */
      username: '',
      summary: '',
      banned: '',
      password: '',
      email: '',
      chb_newsletter: '',

      // lost password 25.04.22
      new_password: '',
      new_password_repeat: '',
      email_pswpin_code: '',
  };

  constructor(props) {
      super(props);
    
      this.state = {
          formData: { ...this.emptyFormData },
          formErrors: { ...this.emptyFormErrors },
          submit_disabled: false,
          logged_in_success: 0,
          show_password_text: 0,
          
          // lost password 25.04.22
          show_new_password_text: 0,
          show_new_password_repeat_text: 0,
          countdown: null,
          display_lostpw_login_btn: false,
      }; 

      this.display = props.display || 'login';
      this.hidden = props.hidden || false;
  }

  componentDidMount() {
    this.logged_in = window.AppRef.current.get_is_signed();

    const login_email = Utils.localSorageGetWithExpiry('login_email_' + i18n.resolvedLanguage);

    if (!!login_email)
    {
      this.state.formData.username = login_email; // sign_in
      this.state.formData.email = login_email; // lost_pw

      this.setState({formData: this.state.formData});
    }
  }

  set_is_signed(is_signed){
    
    this.setState({logged_in_success:is_signed});
  }

  handle_submit(event) {
    event.preventDefault();
  
    this.setState({submit_disabled: true}, () => {
      if (this.display === 'lost-password')
      {
        this.lost_password();
      }
      else if(this.display === 'login') 
      {
        window.AppRef.current.login(false,this.state.formData,null,()=>{
          this.set_is_signed(1);
        },(resp)=>{
          this.setState({submit_disabled:false});
          this.get_xhr_messages(resp.messages);
        });
      }
    });
  }

  lost_password() {
    Utils.get_server_data(
      '',
      {
        ajax_event:'lost_password',
        APICACHE:'false'
      }, 
      {
        ajax_event: 'lost_password',
        formData: JSON.stringify(this.state.formData),
      }
    )
    .then((res)=>{

      if(res.messages)
      {
        this.get_xhr_messages(res.messages);
      }

      this.setState({submit_disabled: false});

      if (res.success)
      {
        var formErrors = this.state.formErrors;

        formErrors.email = i18n.t('lostPasswordChanged');
        formErrors.summary = '';

        this.setState({formErrors: formErrors, display_lostpw_login_btn: true});
      } 
    });
  }

  get_xhr_messages(messages)
  {
      Object.keys(messages).forEach((key) => messages[key] = messages[key].join('<br>'));

      this.setState({formErrors : Object.assign({ ...this.emptyFormErrors }, messages)});
  }
  
  handle_change(event, formDataKey, force_value = null) {
    const formData = this.state.formData;

    formData[formDataKey] = force_value !== null ? force_value : event.target.value;

    this.setState({formData});
  }

  toggle_forms(event)
  { 
      const formData = this.state.formData;
      let formErrors = this.state.formErrors;

      Utils.localSorageSetWithExpiry('login_email_' + i18n.resolvedLanguage, formData.username, Number.MAX_SAFE_INTEGER);

      event.preventDefault();
      event.stopPropagation();
      this.setState({formErrors: { ...this.emptyFormErrors }});
      this.display  = this.display === 'login' ? 'lost-password' : 'login'; 

      if(this.display == 'lost-password')
      {
        if (!!formData.email)
        {
          formData.force_resend_email_pin_code = 1;

          formData.email = Utils.localSorageGetWithExpiry('login_email_' + i18n.resolvedLanguage);

          Utils.get_server_data(
            '',
            {
              ajax_event:'resend_email_pin_code',
              APICACHE:'false'
            }, 
            {
              ajax_event: 'resend_email_pin_code',
              formData: JSON.stringify(formData),
            }
          );
        }
      }
      else 
      {
        formData.new_password = '';
        formData.new_password_repeat = '';
        formData.email_pswpin_code = '';

        formErrors.summary = '';
 
        this.setState({formData, formErrors, display_lostpw_login_btn: false});
      }
  }

  on_code_refresh_click() {
    const {formData, countdown } = this.state;

    if (this.state.countdown <= 0)
    {
      this.setState({countdown: 30}, () => {
        let timer = setInterval(() => {
            if (--this.state.countdown < 1) 
            {
              
               Utils.get_server_data(
                  '',
                  {
                    ajax_event:'resend_email_pin_code',
                    APICACHE:'false'
                  }, 
                  {
                    ajax_event: 'resend_email_pin_code',
                    formData: JSON.stringify(formData),
                  }
                );

              clearInterval(timer);
            }

            this.setState({countdown: this.state.countdown});
          }, 1000);
      });
    }
  };

  render() {

    const {formData, formErrors, submit_disabled, countdown, display_lostpw_login_btn } = this.state;

    const login_newsletter_sent = Utils.localSorageGetWithExpiry('login_newsletter_sent_' + i18n.resolvedLanguage);
    const show_chb_newsletter = login_newsletter_sent == null || !login_newsletter_sent;  // hírlevél checkbox csak akkor jelenik meg, ha localstorage szerint még nincs feliratkozva
    
    if(this.state.logged_in_success==1){
      return <NavigateTo toURL="/"></NavigateTo>
    }
  
    if (this.hidden) return  '';

    return <div className={`container page_sign_in ${this.display}`}>
          <div className="content">
          
          {this.display === 'login' ? 
            <div className="form_wrapper">
              <h2>{i18n.t('signInTitle')}</h2>
              
              <form onSubmit={(e) => this.handle_submit(e)}>
                
                  <div className={`field ${formErrors.username !== '' && formErrors.banned === '' ? "error" : ""}`}>
                      <input placeholder={i18n.t('signInEmail')} name="app_username" type="email" value={formData.username} onChange={(e) => this.handle_change(e, 'username')} />
                      {(formErrors.username.length) ? <div className="form_error"  dangerouslySetInnerHTML={{__html: formErrors.username}}></div> : '' }
                      {(formErrors.banned.length) ? <div className="form_error banned" dangerouslySetInnerHTML={{__html: formErrors.banned}}></div> : '' }
                  </div>

                  <div className={`field password_field ${formErrors.password !== '' ? "error" : ""}`}>
                      <input placeholder={i18n.t('signInPassword')} name="app_password" type={((this.state.show_password_text===1) ? 'text' : 'password')} value={formData.password} onChange={(e) => this.handle_change(e, 'password')} /> 
                      <ReactSVG onClick={()=>this.setState({'show_password_text':Math.abs(this.state.show_password_text-1)})} className={`input_eye_icon`+((this.state.show_password_text===0) ? '_closed' : '')} src={`assets/images/eye`+((this.state.show_password_text===0) ? '-closed' : '')+`.svg`}></ReactSVG>
                      {(formErrors.password.length) ? <div className="form_error" dangerouslySetInnerHTML={{__html: formErrors.password}}></div> : '' } 
                      {(formErrors.summary.length) ? <div className="form_error" dangerouslySetInnerHTML={{__html: formErrors.summary}}></div> : '' }
                  </div> 
 
                  {/* HÍRLEVÉL IDEIGLENESEN DIREKT KIKAPCSOLVA */}
                  {/*false && */show_chb_newsletter ? 
                  <div className={`field checkbox ${formErrors.chb_newsletter !== '' ? "error" : ""}`}>
                    <div className="checkbox">
                      <input id="chb_newsletter" type="checkbox" value="1" onChange={(e) => this.handle_change(e, 'chb_newsletter')} /> 
                      <label htmlFor="chb_newsletter" dangerouslySetInnerHTML={{__html: i18n.t('signInChbNewsletter')}}></label>
                    </div> 
                    {(formErrors.chb_newsletter.length) ? <div className="form_error">{formErrors.chb_newsletter}</div> : '' } 
                  </div> : ''}

                  <div className={`field`}>
                      <input disabled={submit_disabled} type="submit" value={i18n.t('signInNext')} />
                  </div>

                  <div className={`field`}>
                    <a data-type="in_app" className="lost_password" href='lost-password' onClick={(e) => this.toggle_forms(e)}>{i18n.t('signInLostPassword')}</a>
                  </div>

              </form> 

              {/*<Link data-type="in_app" className="account_create" to="/account_create">{i18n.t('signInRegistration')}</Link>*/}

            </div>
          : ''}

          {this.display === 'lost-password' ? 
            <div className="form_wrapper">
              <h2>{i18n.t('lostPasswordTitle')}</h2>

              <p dangerouslySetInnerHTML={{__html: i18n.t('lostPasswordText')}}></p>
            
              <form onSubmit={(e) => this.handle_submit(e)}>  
                {!display_lostpw_login_btn ? <div className={`field email_pswpin_code ${formErrors.email_pswpin_code !== '' ? "error" : ""}`}>
                    <input placeholder={`${i18n.t('lostPasswordCode')} *`} type="text" value={formData.email_pswpin_code} onChange={(e) => this.handle_change(e, 'email_pswpin_code')} />
                    <div className="html_after_input"><ReactSVG onClick={() => this.on_code_refresh_click()} className="refresh_icon" src={`assets/images/refresh.svg`}></ReactSVG>{countdown ? <span className="countdown" dangerouslySetInnerHTML={{__html: i18n.t('pinCodeResendText').replace('{x}', countdown)}}></span> : ''}</div>
                    {(formErrors.email_pswpin_code.length) ? <div className="form_error" dangerouslySetInnerHTML={{__html: formErrors.email_pswpin_code}}></div> : '' }
                </div> : ''}

                <div className={`field ${formErrors.email !== '' ? "error" : ""}`}>
                    <input disabled placeholder={`${i18n.t('lostPasswordEmail')} *`} type="email" value={formData.email} onChange={(e) => this.handle_change(e, 'email')} />
                    <div className="form_explanation">{i18n.t('lostPasswordEmailRules')}</div>
                    {(formErrors.email.length) ? <div className="form_error" dangerouslySetInnerHTML={{__html: formErrors.email}}></div> : '' }
                    {(formErrors.summary.length) ? <div className="form_error" dangerouslySetInnerHTML={{__html: formErrors.summary}}></div> : '' }
                </div> 

                {display_lostpw_login_btn ? <div className={`field`}>
                  <input className="button" type="button" onClick={(e) => this.toggle_forms(e)} value={i18n.t('signInTitle')} />
                </div> : ''} 

                {!display_lostpw_login_btn ?<div className={`field password_field ${formErrors.password !== '' ? "error" : ""}`}>
                    <input placeholder={i18n.t('lostPasswordNewPassword')} name="app_new_password" type={((this.state.show_new_password_text===1) ? 'text' : 'password')} value={formData.new_password} onChange={(e) => this.handle_change(e, 'new_password')} /> 
                    <ReactSVG onClick={()=>this.setState({'show_new_password_text':Math.abs(this.state.show_new_password_text-1)})} className={`input_eye_icon`+((this.state.show_new_password_text===0) ? '_closed' : '')} src={`assets/images/eye`+((this.state.show_new_password_text===0) ? '-closed' : '')+`.svg`}></ReactSVG>
                    <div className="form_explanation">{i18n.t('lostPasswordNewPasswordRules')}</div>
                    {(formErrors.new_password.length) ? <div className="form_error" dangerouslySetInnerHTML={{__html: formErrors.new_password}}></div> : '' } 
                </div>  : ''}

                {!display_lostpw_login_btn ? <div className={`field password_field ${formErrors.password !== '' ? "error" : ""}`}>
                    <input placeholder={i18n.t('lostPasswordNewPasswordRepeat')} name="app_new_password_repeat" type={((this.state.show_new_password_repeat_text===1) ? 'text' : 'password')} value={formData.new_password_repeat} onChange={(e) => this.handle_change(e, 'new_password_repeat')} /> 
                    <ReactSVG onClick={()=>this.setState({'show_new_password_repeat_text':Math.abs(this.state.show_new_password_repeat_text-1)})} className={`input_eye_icon`+((this.state.show_new_password_repeat_text===0) ? '_closed' : '')} src={`assets/images/eye`+((this.state.show_new_password_repeat_text===0) ? '-closed' : '')+`.svg`}></ReactSVG>
                    <div className="form_explanation">{i18n.t('lostPasswordNewPasswordRules')}</div>
                    {(formErrors.new_password_repeat.length) ? <div className="form_error" dangerouslySetInnerHTML={{__html: formErrors.new_password_repeat}}></div> : '' } 
                </div>  : ''}

                {!display_lostpw_login_btn ? <div className={`field`}>
                  <input disabled={submit_disabled} type="submit" value={i18n.t('lostPasswordSubmit')} />
                </div>  : ''}
              </form> 

              {!display_lostpw_login_btn ? <a data-type="in_app" className="sign_in" href="lost-password" onClick={(e) => this.toggle_forms(e)}>{i18n.t('lostPasswordLogin')}</a> : ''}

            </div>
          : ''}

        </div>
        
      </div>
    }
}

export default SignIn;